/**
 * Returns string stripped of double quotes
 *
 * @param {string} - string to be stripped
 * @returns {string or Object} - either 1. string stripped of " or 2. original object if it wasn't a string
 */
export default str => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str.replace(/"/g, '');
};
